import { TFunction } from 'i18next';

export const emailValidation = (value: string, t: TFunction) => {
  if (!value) {
    return t('Email is required');
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return t('Invalid email format. Please enter a valid address.');
  }

  return undefined;
};

export const passwordValidation = (value: string) => {
  if (!value) {
    return 'Password is required';
  }

  if (value.length < 10) {
    return 'Password must be at least 10 characters long';
  }

  if (!/[A-Z]/.test(value)) {
    return 'Password must include an uppercase letter';
  }

  if (!/[0-9!@#$%^&*(),.?":{}|<>]/.test(value)) {
    return 'Password must include a number or symbol';
  }

  return undefined;
};

export const getPasswordRequirements = (value: string, t: TFunction) => {
  return [
    { label: t('At least 10 characters long'), valid: value.length >= 10 },
    { label: t('Contains 1 uppercase character'), valid: /[A-Z]/.test(value) },
    { label: t('Contains 1 number or symbol'), valid: /[0-9!@#$%^&*(),.?":{}|<>]/.test(value) },
  ];
};
